import { APITransport } from '@client/transports/api';

export const RoutingService = {
  deleteRoute(body) {
    return APITransport.post({
      path: '/rest/domain/delete/signatures',
      body
    });
  },
  findByEmail(body) {
    return APITransport.post({
      path: '/rest/domain/execute/findgroups',
      body
    });
  },
  getAll() {
    return APITransport.get({
      path: '/rest/domain/signatures'
    });
  },
  saveRouteOrder(orderedArray) {
    return APITransport.post({
      path: '/rest/domain/execute/reordersignatures',
      body: {
        orderedArray
      }
    });
  },
  updateRoute(body) {
    return APITransport.post({
      path: '/rest/domain/save/signatures',
      body
    });
  }
};
